import { SimplePage } from '@dex/bubl-dash';
import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import VideoTopicsSort from './Components/VideoTopicsSort';

export default function (app, settings) {

    app.addRoute({
        name: settings.key,
        zone: settings.zone,
        caps: settings.indexCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: settings.indexTitle,
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            table: {
                title: settings.title,
                getFetch: settings.indexFetch,
                preFetchFilters: settings.indexFetchParams,
                getSearchFields: settings.indexSearchFields,
                getQuickSearch: settings.indexQuickSearch,
                getColumns: settings.indexColumns
            }
        },
    });

    app.addRoute({
        name: settings.key + "Sort",
        zone: settings.zone,
        path: settings.key + "/reorder",
        caps: settings.indexCaps,
        component: SimplePage,
        componentProps: {
            header: {
                getTitle: settings.indexTitle,
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            page: VideoTopicsSort,
        },
    });

}